export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST'
export const GET_COUNTRY_LIST_REQUEST = 'GET_COUNTRY_LIST_REQUEST'
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS'
export const GET_COUNTRY_LIST_FAILURE = 'GET_COUNTRY_LIST_FAILURE'

export const getCountryListRequest = () => ({ type: GET_COUNTRY_LIST_REQUEST })
export const getCountryListSuccess = (data) => ({ type: GET_COUNTRY_LIST_SUCCESS, data })
export const getCountryListFailure = (error) => ({ type: GET_COUNTRY_LIST_FAILURE, payload: error })
